import { load,sources} from '@fingerprintjs/fingerprintjs';
import initCacheFun from '@/utils/cache';
import {createId} from '@/utils/index';
import Cookies from 'js-cookie'

const $cache = initCacheFun(false);
//const $session = initCacheFun(true);

const browserKeyCacheKey = "webScoketId";
// 加入随机Key防止用户浏览器Key重复
// 这个随机Key放在缓存中，防止用户浏览器Key重复
const browserRandomIdKey = "webRId";
function getBrowserRandomId() {
    if(getBrowserRandomId.browserRandomId){
        return getBrowserRandomId.browserRandomId;
    }
    var id = $cache.get(browserRandomIdKey);
    if(id){
        getBrowserRandomId.browserRandomId = id;
        return id;
    }
    id = Cookies.get(browserRandomIdKey);
    if(id){
        getBrowserRandomId.browserRandomId = id;
        return id;
    }
    id = createId(8);
    $cache.set(browserRandomIdKey,id);
    Cookies.set(browserRandomIdKey,id);
    getBrowserRandomId.browserRandomId = id;
    return id;
}

export var browserKey = "";
const getBrowserKeyPromise = (async () => {
	// 加入随机Key防止用户浏览器Key重复
    sources[browserRandomIdKey]= getBrowserRandomId;
	var fp = await load();
    //window.FingerprintJS=FingerprintJS;
    //const getComponents = loadBuiltinSources({ cache: {}, debug })
	var result = await fp.get();
	var id = (result || {}).visitorId;
	if (id) {
        browserKey = id;
        $cache.set(browserKeyCacheKey,id);
		return id;
	}
	return Promise.reject('获取浏览器唯一标识失败');
})();
export function getBrowserKeyAsync(){
    return getBrowserKeyPromise;
};
export function getBrowserKey() {
    if(browserKey){
        return browserKey;
    }
    var id = $cache.get(browserKeyCacheKey);
    if(id){
        return id;
    }
    return "";
};
